/**
 * Stacking order inside the Create User wizard (PD-4064).
 *
 * Stated explicitly because KeyDS cannot work it out on its own. A Popover's
 * z-index is `currentZIndex + zIndex`, where currentZIndex comes from the nearest
 * StackingContextProvider — and Wizard never provides one: it reaches for
 * Modal/Manager and ResponsiveModalWrapper directly rather than Modal's own
 * wrapper, which is the only thing in the library that does.
 *
 * So every Popover inside the wizard, including the one behind each Select's
 * dropdown, computes 0 + 0 and renders *under* the wizard unless told otherwise.
 * Anything in here that opens a menu has to pass POPOVER_Z_INDEX.
 *
 * WIZARD_Z_INDEX matches ResponsiveModalWrapper's own default; passing it
 * explicitly keeps the two numbers visibly related.
 *
 * Its own module rather than the wizard's, so the steps can import it without a
 * cycle back through index.jsx.
 */
export const WIZARD_Z_INDEX = 100;

export const POPOVER_Z_INDEX = WIZARD_Z_INDEX + 1;
